import clsx from 'clsx';
import React, { useCallback } from 'react';
import { Stack } from '../Stack';
import { Text } from '../Text';
import './TextContainer.css';
export function TextContainer(props) {
    const { children, elementType = 'div', className, ...rest } = props;
    const ElementType = useCallback((props) => React.createElement(Stack, { elementType: elementType, ...props }), [elementType]);
    return (React.createElement(Text, { ...rest, elementType: ElementType, className: clsx('mollie-ui-text-container', className) }, children));
}
//# sourceMappingURL=TextContainer.js.map